// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
   apiKey: "AIzaSyDWsv4qZCHEn0X4MI8zojuuGhiIf5en16s",
  authDomain: "instagram-clone-bf30f.firebaseapp.com",
  projectId: "instagram-clone-bf30f",
  storageBucket: "instagram-clone-bf30f.firebasestorage.app",
  messagingSenderId: "431932390937",
  appId: "1:431932390937:web:5bdacda7e92acd85e73488",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth();
